export default {
  methods: {
    /**
     * 商品詳細画面URL
     */
    getItemDetailUrl (janCode) {
      if (!janCode || typeof janCode !== 'string') {
        return ''
      }
      return `/store/cmdty/detail/${janCode}`
    },
    /**
     * 商品画像URL
     */
    getItemImageUrl (janCode) {
      if (!janCode || typeof janCode !== 'string') {
        return ''
      }
      return `/img/item/${janCode}_180.jpg`
    },
    /**
     * レビュー詳細画面URL
     */
    getReviewDetailUrl (reviewId, params) {
      if (!reviewId || !Number.isInteger(reviewId)) {
        return ''
      }
      let qstr = params && params.skuCodes
        ? '?' + Object.keys(params).reduce((tmp, key) => {
          if (key !== 'count' && key !== 'start' &&
              key !== 'isComment' && key !== 'comments' && key !== 'isImage') {
            let val = params[key]
            tmp.push(`${key}=${Array.isArray(val) ? val.join('+') : val}`)
          }
          return tmp
        }, []).join('&')
        : ''
      return `/store/review/detail/${reviewId}${qstr}`
    },
    /**
     * 商品別レビュー画像一覧画面URL
     */
    getReviewImageUrl (janCode) {
      if (!janCode || typeof janCode !== 'string') {
        return ''
      }
      return `/store/review/item/${janCode}/media`
    },
    /**
     * レビュー投稿画面URL
     */
    getReviewPostUrl (janCode, params) {
      if (!janCode || typeof janCode !== 'string') {
        return ''
      }
      if (params === 'isDetail') {
        return `/store/review/item/${janCode}/post?${params}`
      }
      return `/store/review/item/${janCode}/post`
    },
    /**
     * 商品別レビュー一覧画面URL
     */
    getItemReviewUrl (janCode) {
      if (!janCode || typeof janCode !== 'string') {
        return ''
      }
      return `/store/review/item/${janCode}`
    },
    /**
     * ユーザー別レビュー一覧画面URL
     */
    getUserReviewUrl (nickname) {
      if (!nickname || typeof nickname !== 'string') {
        return ''
      }
      const encoded = encodeURI(nickname)
      return `/store/review/user?nickname=${encoded}`
    },
    /**
     * ユーザー別レビュー一覧画面URL
     */
    getReviewByUserUrl (nickname, followId) {
      if (!nickname || typeof nickname !== 'string' ||
          !followId || !Number.isInteger(followId)) {
        return ''
      }
      const encoded = encodeURI(nickname)
      return `/store/review/user?nickname=${encoded}&follow_id=${followId}`
    },
    /**
     * デフォルトユーザー画像URL
     */
    getDefaultUserImageUrl () {
      return 'https://www.muji.com/jp/store/review/img/avatar_default.png'
    },
    /**
     * レビュー報告画面URL
     */
    getReviewReportUrl (reviewId) {
      if (!reviewId || !Number.isInteger(reviewId)) {
        return ''
      }
      return `/store/review/report/${reviewId}`
    },
    /**
     * コメント報告画面URL
     */
    getCommentReportUrl (reviewId, commentId) {
      if (!reviewId || !Number.isInteger(reviewId) ||
          !commentId || !Number.isInteger(commentId)) {
        return ''
      }
      return `/store/review/report/${reviewId}/${commentId}`
    },
    /**
     * レビュー投稿履歴画面URL
     */
    getReviewHistoryUrl () {
      return '/store/review/history'
    },
    /**
     * 購入履歴画面URL
     */
    getOrderItemListUrl () {
      return '/store/cust/order/itemlist'
    },
    /**
     * フォロー中のユーザー画面URL
     */
    getFollowingUrl () {
      return '/store/review/following/'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/urls.js